<div class="restaurant-container">
  <app-restaurant-header></app-restaurant-header>

   <!-- Breadcrumbs -->
   <nav class="breadcrumbs" *ngIf="breadcrumbs.length > 0" aria-label="breadcrumb">
    <a routerLink="/">Home</a>
    <ng-container *ngFor="let b of breadcrumbs; let last = last">
      <span> / </span>
      <ng-container *ngIf="!last">
        <a [routerLink]="b.url">{{ b.label }}</a>
      </ng-container>
      <ng-container *ngIf="last">
        <span aria-current="page">{{ b.label }}</span>
      </ng-container>
    </ng-container>
  </nav>

  <div class="main-content">
    <div *ngIf="product">
      <article class="menu-item">
        <div class="menu-header">

          <img *ngIf="product.cdn_url" [src]="product.cdn_url" [alt]="product.descart" class="product-image" />

          <div class="menu-title-price">
            <h2 class="menu-title">{{ product.descart }}</h2>

            <div class="menu-price">
              <span class="currency">€</span>
              <span class="amount">{{ product.prezzo | number:'1.2-2' }}</span>
            </div>
          </div>

          <p class="menu-description">
            {{ product.descrizione_estesa }}
          </p>
        </div>

        <section class="ingredients-section" *ngIf="product.ingredienti?.length">
       <h3 class="ingredients-title">{{ 'PRODUCT.INGREDIENTS' | translate }}</h3>
          <div class="ingredients-list" role="list">
            <ng-container *ngFor="let ingredient of product.ingredienti">
              <ng-container *ngFor="let dato of ingredient.dati">
                <div class="ingredient-card" role="listitem" tabindex="0">
                  <img
                    [src]="dato.icona"
                    [alt]="dato.descrizione"
                    class="ingredient-image"
                    loading="lazy"
                  />
                  <span class="ingredient-name">{{ dato.descrizione }}</span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </section>

        <section class="extras-section" *ngIf="hasInlineAttributes()">
          <div class="extras-header">
            <h3 class="ingredients-title">Extra</h3>
          </div>

          <div class="extras-list">
            <div class="extra-option-card" *ngIf="loadingAttributi">
              <div class="extra-option-content">
                <span class="extra-label">Caricamento extra...</span>
              </div>
            </div>

            <button
              *ngFor="let attribute of product.attributi"
              type="button"
              class="extra-option-card"
              [ngClass]="{
                'extra-option-card-selected': attribute.selected,
                'extra-option-card-unavailable': canSelectAttributes() && !isAttributeAvailable(attribute),
                'extra-option-card-readonly': !canSelectAttributes()
              }"
              [disabled]="!canSelectAttributes()"
              (click)="toggleAttribute(attribute)">
              <div class="extra-option-content">
                <div class="checkbox-section">
                  <span class="checkbox-container">
                  <span *ngIf="canSelectAttributes()" class="checkbox-custom" [class.checked]="attribute.selected"></span>
                  <span class="extra-copy">
                      <span class="extra-label">{{ attribute.descrizione }}</span>
                      <span *ngIf="canSelectAttributes()" class="extra-meta" [ngClass]="{'extra-meta-danger': !isAttributeAvailable(attribute)}">
                        {{ getAttributeAvailabilityLabel(attribute) }}
                      </span>
                    </span>
                  </span>
                </div>
                <span class="extra-price extra-price-inline" *ngIf="showAttributePrice(attribute)">
                  <span class="currency-symbol">€</span>
                  <span class="price-value">{{ getAttributePrice(attribute) | number:'1.2-2' }}</span>
                </span>
              </div>
            </button>
          </div>
        </section>
      </article>
    </div>

    <div *ngIf="!product">
     <app-loading-shimmer></app-loading-shimmer>
    </div>
  </div>

  <!-- Pulsanti per quantità e aggiunta ordine -->
  <div *ngIf="cartService.isCheckoutAvailable()" class="order-controls-container">
    <div class="quantity-controls">
      <button 
        class="quantity-button"
        (click)="removeProduct()"
        aria-label="Decrease quantity"
        [attr.aria-disabled]="quantity <= 0"
        tabindex="0">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/256372321c1ede4140f4856eff8f0ce0736773d21fb361657dfdb8929938b5b4?placeholderIfAbsent=true&apiKey=41d97f281632459facdce4f7e6f0df87"
          alt=""
          class="control-icon"
        />
      </button>
      <span class="quantity-value" aria-live="polite">{{ quantity }}</span>
      <button 
        class="quantity-button"
        (click)="addProduct()"
        aria-label="Increase quantity"
        tabindex="0">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/433d9727a625503c84c9ad43c956774f376dd37ba6668589cde949de8af0a02c?placeholderIfAbsent=true&apiKey=41d97f281632459facdce4f7e6f0df87"
          alt=""
          class="control-icon"
        />
      </button>
    </div>
    <button 
      class="add-order-button"
      (click)="onAddToOrder()"
      aria-label="Add to order"
      [ngClass]="{ 'active': quantity > 0 }"
      [attr.aria-disabled]="quantity <= 0"
      tabindex="0">
   {{ 'PRODUCT.ADD' | translate }}</button>
  </div>
 <app-restaurant-footer></app-restaurant-footer>
</div>
